import React from 'react'
import NetworkError from '@/pages/NetworkError/index'
import Loading from '@/pages/components/common/loading/index'
import { bdCommonTrack } from '@/utils/bdCourier'

const LoadingComponent = ({ isLoading, error }) => {
  if (isLoading) {
    return <Loading tips='正在加载...' visible={true} />
  } else if (error) {
    console.log('errorInfo:' + error)
    bdCommonTrack('LoadingComponent_h5', {
      path: location.href,
      response: JSON.stringify(error),
      resp_time: new Date().valueOf()
    })
    return <NetworkError />
  } else {
    return null
  }
}
export const EmptyLoading = ({ isLoading, error }) => {
  return null
}
export default LoadingComponent
